import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import BasicTable from "../../components/UiComponent/customTable";
import { Container, Row, Button } from "react-bootstrap";
import moment from "moment";
import { formatDate } from "../../utils/date_utils";
import { useQuery } from "@tanstack/react-query";
import useFinanceApi from "../../services/financeApi";
import { GetCurrentUserName } from "../../utils/permissionChecker";
import CustomModal from "../../components/UiComponent/Modal";
import ExpenseForm from "./addExpense";
const Expenses = () => {
  const { t } = useTranslation();
  const loggedInUser = GetCurrentUserName();
  const { get_expenseByDate } = useFinanceApi();
  const [showModal, setShowModal] = useState(false);
  const currentDate = new Date();
  const formattedDate = moment(currentDate).format("YYYY-MM-DD");
  const [selectedDate, setSelectedDate] = useState(formattedDate);
  const getExpenseQuery = useQuery(["expenseByDate", selectedDate], () =>
    get_expenseByDate(selectedDate)
  );

  const expenseData = useMemo(() => {
    return getExpenseQuery.data?.data?.expense || [];
  }, [getExpenseQuery.data]);

  if (getExpenseQuery.isLoading) {
    return <div>Loading...</div>;
  }

  if (getExpenseQuery.isError) {
    return <div>Error: {getExpenseQuery.error.message}</div>;
  }

  const handleShowModal = () => {
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const expenseColumns = [
    {
      header: "expense_for",
      accessorKey: "expense_for",
    },
    {
      header: "expense_type",
      accessorKey: "expense_catagory.name",
    },
    {
      header: "payment_method",
      accessorKey: "payment_method.name",
    },
    {
      header: "payment_reference",
      accessorKey: "payment_reference",
    },
    {
      header: "amount",
      accessorKey: "amount",
    },
  ];
  return (
    <Container fluid>
      <Row>
        <BasicTable
          data={expenseData}
          columns={expenseColumns}
          title={`Expenses on ${formatDate(selectedDate)}`}
          actionButton={
            <div className="d-flex flex-wrap align-items-center justify-content-between">
              <input
                type="date"
                value={selectedDate}
                className="form-select form-control-sm m-2"
                onChange={(e) => {
                  const inputDate = e.target.value;
                  setSelectedDate(inputDate);
                }}
              />
              <Button
                variant="btn btn-info btn-sm m-2"
                onClick={() => handleShowModal()}
              >
                {t("add_expense")}
              </Button>
            </div>
          }
          footer={
            <tr>
              <th scope="row" colspan="5" className="text-right">
                Total
              </th>
              <td>
                {expenseData
                  .reduce((sum, item) => sum + item.amount, 0)
                  .toFixed(2)}
              </td>
            </tr>
          }
        />
      </Row>
      <CustomModal
        show={showModal}
        title="Register new expense"
        onHide={handleCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
        content={<ExpenseForm closeModal={handleCloseModal} />}
      />
    </Container>
  );
};

export default Expenses;
